import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h4.5m7.5 -10v-4a2 2 0 0 0 -2 -2h-2","key":"svg-0"}],["path",{"d":"M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2","key":"svg-1"}],["path",{"d":"M15 18a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-2"}],["path",{"d":"M20.2 20.2l1.8 1.8","key":"svg-3"}]]

const IconClipboardSearch = createReactComponent('outline', 'clipboard-search', 'ClipboardSearch', __iconNode);

export default IconClipboardSearch;